import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { PAGE_TEXT } from '../../lang';
import {
  useUpdateDrcApproval,
  type DsrcApproval,
  useCreateDsrcApproval,
} from '../../graphql';
import { Accordion, Alert, type AlertDetails } from '../../../../components';
import { DRCApprovalBox } from './DRCApprovalBox';

type DRCApprovalContentProps = {
  hasDsrcApprovalCreated: boolean;
  dsrcApproval: DsrcApproval;
  isViewMode?: boolean;
  drcRequired: boolean;
  submitDsrcApproval?: () => void;
  refetchAssessment?: () => void;
};

export const DRCApprovalContent: React.FunctionComponent<
  DRCApprovalContentProps
> = props => {
  const { applicationId = '' } = useParams();
  const {
    isViewMode = false,
    drcRequired,
    dsrcApproval,
    hasDsrcApprovalCreated,
    submitDsrcApproval = () => {},
    refetchAssessment = () => {},
  } = props;

  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'info',
  });

  let isCreateMode = !hasDsrcApprovalCreated;

  const createDsrcApproval = useCreateDsrcApproval();
  const updateDrcApproval = useUpdateDrcApproval();
  const handleSubmit = async (value: DsrcApproval): Promise<void> => {
    try {
      const variables = {
        input: {
          applicationId,
          ...value,
        },
      };

      if (isCreateMode) {
        await createDsrcApproval({
          variables,
        });
        isCreateMode = false;
      } else {
        await updateDrcApproval({ variables });
      }
      refetchAssessment();
      submitDsrcApproval();
    } catch (error: any) {
      setAlertDetails({
        alertContent: `Error Occurs.` + (error as Error).message,
        alertType: 'error',
      });
      setOpenAlert(true);
    }
  };

  return (
    <ContentBox>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />

      <Accordion
        className="w-full"
        defaultExpanded
        title={PAGE_TEXT.DSRC_APPROVAL_DETAILS.ASSESSMENT.TITLE}
        details={
          <DRCApprovalBox
            initialValues={dsrcApproval}
            isViewMode={isViewMode}
            drcRequired={drcRequired}
            onSubmit={handleSubmit}
          />
        }
      />
    </ContentBox>
  );
};

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  Accordion {
    margin-bottom: 1rem;
  }
`;
